import { Component, computed, effect, signal, inject, Optional } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { SidebarService } from 'src/app/admin/servicies/sidebar.service';
import { PaymentService } from '../services/payment.service';
import { PaymentHistory } from 'src/app/interfaces/payment-history';
import { ResultOfT } from '../models/response/result';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.sass'],
  providers: [DialogService],
  standalone: false
})
export class PaymentHistoryComponent extends BaseComponent {
  loading = false;
  isVisible = signal(false);
  paymentHistory: PaymentHistory[];
  // private salesOrderIdFromSidebar = signal<number | null>(null);

  // private salesOrderId = computed(() => {
  //   const sidebarValue = this.salesOrderIdFromSidebar();
  //   return sidebarValue || null;
  // });

  constructor(
    messageService: MessageService,
    private sidebarService: SidebarService,
    private paymentService: PaymentService,
    @Optional() private dialogConfig: DynamicDialogConfig
  ) {
    super(messageService);

    this.sidebarService.sidebarData()
      .pipe(takeUntilDestroyed())
      .subscribe((data: any) => {
        const salesOrderId = data?.salesOrderId;
        if (salesOrderId && salesOrderId > 0) {
          this.getPaymentHistory(salesOrderId);
          this.isVisible.set(true);
        } else {
          this.isVisible.set(false);
        }
      });

    
  }

  getPaymentHistory(salesOrderId: number) {
      if (!salesOrderId) {
      console.warn('No sales order ID available for payment history');
      return;
    }

    this.loading = true;
    this.paymentService.getPaymentHistory(salesOrderId).subscribe({
      next: (result: ResultOfT<PaymentHistory[]>) => {
        this.processResult<PaymentHistory[]>(result, () => {
          if (result?.isSuccess && result.responseModel) {
            this.paymentHistory = result.responseModel;
            console.log('Payment history data:', result.responseModel); 
          } else {
            this.paymentHistory = [];
            this.showInfoMessage('No payment history found for this order.');
          }
        });
        this.loading = false;
      },
      error: (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message || 'Failed to load payment history');
        this.paymentHistory = [];
        this.loading = false;
      }
    });
  }


exportToCSV(): void {
  if (!this.paymentHistory || this.paymentHistory.length === 0) {
    return;
  }

  const csvHeaders = [
    'Description',
    'Event Type',
    'Payment Status',
    'Created Date',
    'Timezone',
    'Created By'
  ];

  const csvData = this.paymentHistory.map(payment => [
    this.escapeCsvValue(payment.description || ''),
    this.escapeCsvValue(payment.eventType || ''),
    this.escapeCsvValue(payment.paymentStatus || ''),
    this.formatDateForCSV(payment.createdAt),
    this.escapeCsvValue(payment.timezone || ''),
    this.escapeCsvValue(payment.createdByName || '')
  ]);

  const csvContent = [
    csvHeaders.join(','),
    ...csvData.map(row => row.join(','))
  ].join('\n');

  this.downloadCSV(csvContent, 'payment-history.csv');
}

private escapeCsvValue(value: string): string {
  if (!value) return '""';
  
  const escaped = value.replace(/"/g, '""');
  if (escaped.includes(',') || escaped.includes('\n') || escaped.includes('"')) {
    return `"${escaped}"`;
  }
  return escaped;
}

private formatDateForCSV(date: string | Date): string {
  if (!date) return '""';
  
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return '""';
  
  const formatted = dateObj.toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  
  return `"${formatted}"`;
}

private downloadCSV(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}


  closeSidebar() {
    this.isVisible.set(false);
    this.paymentHistory = [];
    this.sidebarService.close();
  }

}